import { toPng } from 'html-to-image';

//@ts-ignore
export default ({ app }, inject: any) => {
    const capturedScreenshots: { [key: number]: string } = {}; // Store screenshots by page number
    const pageOrder: number[] = []; // Maintain page order

    inject('captureScreenshot', async (documentId: string, page: number, pdfModule: any, submit = false) => {
        if (!pdfModule || !documentId || typeof page !== 'number') return null;

        const content = document.getElementById(documentId);
        if (!content) return null;

        try {
            const imgData = await toPng(content, {
                quality: 1,
                cacheBust: true,
                //@ts-ignore
                useCORS: true,
                width: content.scrollWidth,
                height: content.scrollHeight,
                style: { transform: 'scale(1)', backgroundColor: '#FFFFFF' },
            });

            const img = new Image();
            img.src = imgData;
            await new Promise(resolve => (img.onload = resolve));

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx && ctx.drawImage(img, 0, 0);

            const croppedImgData = canvas.toDataURL('image/png');

            if (!capturedScreenshots[page]) pageOrder.push(page);
            capturedScreenshots[page] = croppedImgData; // Replace or store screenshot

            if (submit && typeof pdfModule.storePages === 'function') {
                const orderedScreenshots = pageOrder.sort((a, b) => a - b).map(p => capturedScreenshots[p]);
                await pdfModule.storePages(orderedScreenshots);
            }

            return croppedImgData;
        } catch {
            return null;
        }
    });
};
